import { formatPrice } from "@/lib/constants";
import { useLang, t, prodName } from "@/lib/i18n";

export default function ProductRow({ product }) {
  const lang = useLang();
  const price = formatPrice(product);
  const note = product.price_note === "cad." ? t(lang, "cadNote") : product.price_note;
  return (
    <div
      data-testid={`product-row-${product.id}`}
      className="py-3 border-b border-[#E8DFC9]/70 last:border-b-0"
    >
      <div className="flex items-baseline">
        <h3 className="font-display font-semibold text-lg text-[var(--text)] leading-snug">
          {prodName(product, lang)}
        </h3>
        {product.is_new && (
          <span className="ml-2 text-[10px] font-cinzel tracking-widest uppercase text-[var(--bordeaux-2)] border border-[#8B1E32]/40 rounded-full px-2 py-px">Nuovo</span>
        )}
        {product.is_recommended && (
          <span className="ml-2 text-[10px] font-cinzel tracking-widest uppercase text-[#B89248] border border-[#C5A059]/50 rounded-full px-2 py-px">Consigliato</span>
        )}
        {price && <span className="price-leader" aria-hidden="true" />}
        {price && (
          <span data-testid={`price-${product.id}`} className="font-display font-bold text-lg text-[var(--bordeaux)] whitespace-nowrap">
            {price}
          </span>
        )}
        {note && (
          <span className="ml-1.5 text-xs text-[var(--muted)] italic whitespace-nowrap">{note}</span>
        )}
      </div>
      {product.description && (
        <p className="text-sm text-[var(--text-2)] mt-0.5 leading-relaxed">{product.description}</p>
      )}
    </div>
  );
}
